<template>
  <div>
    <draggable
      v-model="places"
      class="list-group list-group-flush draggable-list"
      tag="ul"
      :disabled="!customize"
    >
      <transition-group
        type="transition"
        name="flip-list"
      >
        <div
          v-for="component in places"
          :key="component.type+'_'+component.id"
        >
          <client-details
            v-if="component.id === 9 && component.type === 'default'"
            key="client-details"
            :custom-change="customize"
            :side="side"
            :bc-case-id="bcCaseId"
            :rest-amount="restAmount"
          />
          <case-installement-plan
            v-if="component.id === 4 && component.type === 'default'"
            key="case-installement-plan"
            :side="side"
            :custom-change="customize"
          />
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CaseInstallementPlan from './CaseInstallmentPlan.vue'
import ClientDetails from './ClientDetails.vue'

export default {
  inject: ['sharedState'],
  components: {
    CaseInstallementPlan,
    ClientDetails,
    draggable,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    bcCaseId: {
      type: String,
      required: true,
    },
    restAmount: {
      type: Number,
      required: true,
    },
    prefixCaseId: {
      type: [String, null],
      required: true,
    },
  },
  data() {
    return {
      customize: false,
      widgetComponents: [],
    }
  },
  watch: {
    places: {
      handler() {
        this.widgetComponents = [...this.places]
      },
    },
  },
  methods: {
    customizeFunction() {
      this.customize = !this.customize
    },
  },
}
</script>

  <style lang="scss">
  .cancel-btn {
    margin-right: 20px !important;
    margin-top: 10px;
  }
  </style>
